export enum TfaAuthorizedRequestMode {
  ENABLE,
  DISABLE,
  DELETE,
}
